/**
 * Removes top-level properties with null or undefined values from an object.
 *
 * @param obj - The object to clean.
 * @returns A new object with null and undefined properties removed.
 */
export function removeNullOrUndefined<T extends object>(obj: T): Partial<T> {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined) {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as Partial<T>);
}
